// store/slices/sidebarMenuSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type SidebarPermissionMap = Record<string, boolean>;

interface SidebarMenuState {
  permissions: SidebarPermissionMap;
  hasFetchedSidebarPermissions: boolean;
  sidebarPermissionStatus?: string;
}

const initialState: SidebarMenuState = {
  permissions: {},
  hasFetchedSidebarPermissions: false,
  sidebarPermissionStatus: "",
};


const sidebarMenuSlice = createSlice({
  name: "sidebarMenu",
  initialState,
  reducers: {
    setSidebarPermissions(state, action: PayloadAction<SidebarPermissionMap>) {
      state.permissions = action.payload;
    },
    setHasFetchedSidebarPermissions(state, action: PayloadAction<boolean>) {
      state.hasFetchedSidebarPermissions = action.payload;
    },
    setSidebarPermissionStatus(state, action: PayloadAction<string>) {
      state.sidebarPermissionStatus = action.payload;
    },
  },
});

export const { setSidebarPermissions, setHasFetchedSidebarPermissions, setSidebarPermissionStatus } = sidebarMenuSlice.actions;
export default sidebarMenuSlice.reducer;
